import { render, staticRenderFns } from "./SuppliesWrhousngRegistration.vue?vue&type=template&id=c3e0b47e&scoped=true&"
import script from "./SuppliesWrhousngRegistration.vue?vue&type=script&lang=js&"
export * from "./SuppliesWrhousngRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesWrhousngRegistration.vue?vue&type=style&index=0&id=c3e0b47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e0b47e",
  null
  
)

export default component.exports